import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';

import CloseIconNavy from 'images/icons/signals/closesAndCancels/closeTransparent.svg';
import { Container, GlobalStyle } from 'styles/general';

import { HeaderCell, Cell } from '../style';

function PurchaseHistoryByProduct({
  open,
  onClose,
  productDescription,
  data = []
}) {
  return (
    <>
      <GlobalStyle />
      <Container>
        <Dialog
          open={open}
          onClose={onClose}
          fullWidth
          maxWidth="sm"
          className="defaultModal productTableDialog"
          PaperProps={{
            style: {
              width: '237px',
              maxHeightheight: '283px',
              borderRadius: '8px'
            }
          }}
        >
          <DialogTitle
            className="modalHeader bold textAlignCenter cursorMove"
            style={{ paddingRight: '12px', backgroundColor: '#1F2445' }}
          >
            <Typography style={{ fontSize: '12px' }}>
              {productDescription?.toUpperCase() ?? 'HISTÓRICO'}
            </Typography>
            <IconButton
              edge="start"
              onClick={onClose}
              aria-label="close"
              style={{ outline: '0', background: 'none' }}
            >
              <img style={{ width: '12px' }} src={CloseIconNavy} alt="Close" />
            </IconButton>
          </DialogTitle>

          <DialogContent className="modalContent onlyTableProducts pt0 pb0">
            <table
              className="purchaseTable"
              style={{ width: '100%', borderCollapse: 'collapse', margin: '0' }}
            >
              <thead>
                <tr>
                  <HeaderCell className="paddingY" style={{ width: '100px' }}>
                    <span>DATA</span>
                  </HeaderCell>
                  <HeaderCell className="borderLGray right paddingY">
                    <span>QTDE</span>
                  </HeaderCell>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: '1px solid #D2D3D7',
                      paddingTop: '5px'
                    }}
                  >
                    <Cell
                      className="description left colData"
                      style={{ width: '90px' }}
                    >
                      <span className="navyText">{item.date}</span>
                    </Cell>
                    <Cell className="description borderLGray right">
                      <span className="blackText">{item.quantity} kg</span>
                    </Cell>
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
}

export default PurchaseHistoryByProduct;
